import ResumePreviewFrame from './ResumePreviewFrame';
import { CANDIDATE_MODAL_PRIMARY_BTN } from '../constants/candidateFormStyles';

/**
 * Resume upload + parse (staff add/edit candidate & profile).
 */
export default function CandidateResumeSection({
  resumeFile,
  resumePreviewSrc,
  savedResumeLink,
  savedResumeFileName,
  candidateName,
  candidateId,
  resumeText,
  onResumeFileChange,
  onResumeTextChange,
  onClearPreview,
  resumePreviewOpen,
  onResumePreviewOpenChange,
  onParse,
  parsingResume,
  parseMessage,
  saveLabel = 'Add candidate',
  compact = false,
  hidePasteText = true
}) {
  const hasPreview = resumePreviewSrc || savedResumeLink;

  return (
    <div className={compact ? 'space-y-2' : 'space-y-2.5'}>
      <div className="flex flex-col sm:flex-row sm:items-end gap-2">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-1.5">
            <input
              type="file"
              accept=".pdf,.doc,.docx,.txt,.rtf,.wps"
              className="flex-1 min-w-0 text-xs w-full file:mr-2 file:py-1 file:px-2.5 file:rounded-lg file:border-0 file:text-xs file:font-medium file:bg-[hsl(var(--ds-muted))] file:text-[hsl(var(--ds-fg))] hover:file:bg-[hsl(var(--ds-muted))]"
              onChange={e => {
                const file = e.target.files?.[0];
                if (!file) return;
                onClearPreview?.();
                onResumeFileChange(file);
                e.target.value = '';
              }}
            />
            {hasPreview && (
              <ResumePreviewFrame
                iconOnly
                src={resumePreviewSrc || savedResumeLink}
                file={resumeFile}
                fileName={resumeFile?.name || savedResumeFileName}
                candidateName={candidateName}
                candidateId={candidateId}
                modalOpen={resumePreviewOpen}
                onModalOpenChange={onResumePreviewOpenChange}
                compact={compact}
              />
            )}
          </div>
          <div className="text-[10px] text-[hsl(var(--ds-muted-fg))] mt-1">
            {compact
              ? `PDF, DOCX, DOC, TXT, RTF, WPS — auto-saved on ${saveLabel}`
              : `Upload resume (PDF, DOCX, DOC, TXT, RTF, WPS) — saved when you click ${saveLabel}`}
          </div>
        </div>
        <button
          type="button"
          className={`${CANDIDATE_MODAL_PRIMARY_BTN} shrink-0 whitespace-nowrap`}
          onClick={onParse}
          disabled={parsingResume}
        >
          {parsingResume ? 'Parsing…' : 'Parse resume'}
        </button>
      </div>

      {!hidePasteText && onResumeTextChange && (
        <div className="field-with-label">
          <textarea
            className="border border-[hsl(var(--ds-border))] px-2.5 py-1.5 text-xs w-full rounded-lg"
            rows={compact ? 2 : 3}
            placeholder=" "
            value={resumeText}
            onChange={e => onResumeTextChange(e.target.value)}
          />
          <label>Paste Resume Text for Parsing</label>
        </div>
      )}

      {parseMessage && (
        <p
          className={`text-[10px] ${
            parseMessage.includes('Failed') || parseMessage.includes('Upload') || parseMessage.includes('paste')
              ? 'text-red-600'
              : 'text-green-700'
          }`}
        >
          {parseMessage}
        </p>
      )}
    </div>
  );
}
